import { render, staticRenderFns } from "./estudante-historico-academico-func.vue?vue&type=template&id=90f7db4c&"
import script from "./estudante-historico-academico-func.vue?vue&type=script&lang=js&"
export * from "./estudante-historico-academico-func.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports